<template>
  <div class="title-wrapper">
    <Row type="flex" justify="space-between" align="center">
      <Col span="6">
        <img class="title-bg bg-left" src="../../../assets/ranking/title_left.png" />
      </Col>
      <Col span="12" class="title-name">{{name}}</Col>
      <Col span="6">
        <img class="title-bg bg-right" src="../../../assets/ranking/title_right.png" />
      </Col>
    </Row>
  </div>
</template>
<script>
import { Row, Col } from 'vant'
export default {
  name: 'Title',
  components: {
    Row, Col
  },
  props: [
    'name'
  ],
  data () {
    return {
    }
  },
  created () {
  },
  methods: {}
}
</script>
<style lang="less">
.title-wrapper{
  padding: 25px 0;
}
.title-bg{
  width: 84px;
  display: block;
  &.bg-left{
    float: right;
  }
}
.title-name{
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  color: #0B1338;
}
</style>
